import { isDevelopment } from 'util/helpers'

const {
    REACT_APP_AZURE_AD_APP_CLIENT_ID,
    REACT_APP_AZURE_AD_REDIRECT_URL,
    REACT_APP_AZURE_AD_AUTHORITY,
    REACT_APP_NODEJS_API_BASE_URL,
    REACT_APP_SHARE_POINT_SITE_ID,
    REACT_APP_DOTNET_API_FORMULAE_ENGINE,
    REACT_APP_GRAPH_USER_DETAILS_ID,
} = process.env

let Configurations = {
    azureADAppClientId: REACT_APP_AZURE_AD_APP_CLIENT_ID,
    azureADAuthority: REACT_APP_AZURE_AD_AUTHORITY,
    azureADRedirectURL: getAzureADRedirectUrl(),
    apiEndPoints: {
        baseUrl: REACT_APP_NODEJS_API_BASE_URL,
        formulaeEngine: REACT_APP_DOTNET_API_FORMULAE_ENGINE,
        mergeDoc: 'api/mergedoc/',
        edi: 'api/edi/',
        common: 'api/common/',
        getProtectedResource: 'protected-resource',
        admin: 'api/admin/',
    },
    sharePointSiteId: REACT_APP_SHARE_POINT_SITE_ID,
    graph: {
        userDetails: REACT_APP_GRAPH_USER_DETAILS_ID,
    },
}

function getAzureADRedirectUrl() {
    if (isDevelopment()) {
        console.log('Running local development server...')
        return 'http://localhost:3000/'
    }
    return REACT_APP_AZURE_AD_REDIRECT_URL
}

export { Configurations }
